module.exports = __webpack_public_path__ + "img/landing_box05.d4cbc46b.jpg";